import {Set, Record} from 'immutable';
import moment from 'moment';

export class User extends Record({
    uid: null,
    name: null,
    favourites: Set(),
    roles: Set(),
}) {
    hasRole(role) {
        return this.roles.has(role);
    }
}

export const Venue = Record({
    id: null,
    name: null,
    description: null,
});

export class Event extends Record({
    id: null,
    name: null,
    start_time: null,
    adjudicator: null,
    supervisor: null,
    venue: null,
    seconds_per_entry: null,
}) {
    constructor(data) {
        data.start_time = moment(data.start_time);
        super(data);
    }
}

export const Entry = Record({
    id: null,
    draw: null,
    first_name: null,
    surname: null,
    band: null,
    event: null,
    accompanist: null,
    scratched: false,
    start_time: null,
});



/** WEBPACK FOOTER **
 ** ./src/model.js
 **/